var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.711,
    height: 18.848,
    viewBox: "0 0 38.711 18.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6490",
    "data-name": "Path 6490",
    d: "M0,0H35.74",
    transform: "translate(2.563 3.312) rotate(20)",
    fill: "none",
    stroke: "#9d9d9d",
    strokeLinecap: "round",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "noun-eye-3256724",
    d: "M123.751,170.967a4.038,4.038,0,1,1,2.856-1.183A4.04,4.04,0,0,1,123.751,170.967Zm18.459-3.083c-4.4,4.429-9.68,8.468-18.459,8.468s-14.056-4.039-18.459-8.468a1.347,1.347,0,0,1,0-1.912c4.4-4.429,9.68-8.468,18.459-8.468s14.056,4.039,18.459,8.468a1.347,1.347,0,0,1,0,1.912Zm-18.459,5.776a6.732,6.732,0,1,0-4.76-1.972A6.731,6.731,0,0,0,123.751,173.66Z",
    transform: "translate(-104.396 -157.504)",
    fill: "#9d9d9d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisible);
export default __webpack_public_path__ + "static/media/Invisible.82f8faecc2b3dbd3d978550f75518742.svg";
export { ForwardRef as ReactComponent };